import React from 'react'
import { Icon } from '../../../components/common'

export const ChatPenStateBubble = () => (
  <div>
    ... <Icon typeName="midasPen4" />
  </div>
)
